var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTokenPositiveImpact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "124px",
    height: "127px",
    viewBox: "0 0 124 127",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Token-PositiveImpact") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 62,
    cy: 62,
    r: 62
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.2%",
    y: "-1.2%",
    width: "102.4%",
    height: "104.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.15 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\"ESG\"-Game-Screens",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ESG/S/Q1-b/Q2-b/Q3",
    transform: "translate(-237.000000, -113.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(24.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group",
    transform: "translate(183.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Token-PositiveImpact",
    transform: "translate(30.000000, 65.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ic_favorite",
    mask: "url(#mask-2)",
    fill: "#575F69"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.000000, 20.666667)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.3333333,33.3333333 L30,0 L6.66666667,33.3333333 L12.8666667,33.3333333 L0,53.3333333 L23.3333333,53.3333333 L23.3333333,66.6666667 L36.6666667,66.6666667 L36.6666667,53.3333333 L60,53.3333333 L47.1333333,33.3333333 L53.3333333,33.3333333 M67.1333333,33.3333333 L73.3333333,33.3333333 L50,0 L42.0333333,11.3666667 L59.7333333,36.6666667 L53.2333333,36.6666667 L63.9666667,53.3333333 L80,53.3333333 L67.1333333,33.3333333 M43.3333333,56.6666667 L56.6666667,56.6666667 L56.6666667,66.6666667 L43.3333333,66.6666667 L43.3333333,56.6666667 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "ic_favorite",
    mask: "url(#mask-2)",
    fill: "#4BD5AD",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.000000, 74.000000)",
    id: "Path-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,0 L40,10 L36.634,6.634 L23,22 L15,14 L3,26 L0,23 L15,8 L23,16 L33.806,3.806 L30,0 L40,0 Z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenPositiveImpact);
export default __webpack_public_path__ + "static/media/Token-PositiveImpact.be19459c5d3f6c35ff466801cb70ed62.svg";
export { ForwardRef as ReactComponent };